import { useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import { Moment } from 'moment';
import { parseDateToString } from '@utils/helpers';
import { TABLES_REQUEST_TIMEOUT } from './useGetTablesAvailability';

export function useGetRestaurantConfig(
  propertyId: number,
  visitDate: string | Moment,
  restaurant: string,
  enabled = true
) {
  return useQuery({
    queryKey: getRestaurantConfigKey({ propertyId, restaurant, visitDate }),
    queryFn: () => getRestaurantConfig({ propertyId, restaurant, visitDate }),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: enabled && !!restaurant,
  });
}

export async function getRestaurantConfig({
  propertyId,
  visitDate,
  restaurant,
}: {
  propertyId: number;
  visitDate: string | Moment;
  restaurant: string;
}) {
  const date = parseDateToString(visitDate);

  const response = await request.v2.get(`${propertyId}/tables/restaurants/${restaurant}/${date}`, {
    timeout: TABLES_REQUEST_TIMEOUT,
  });
  return response.data;
}

export const getRestaurantConfigKey = ({
  propertyId,
  visitDate,
  restaurant,
}: {
  propertyId: number;
  visitDate: string | Moment;
  restaurant: string;
}) => ['restaurantConfig', propertyId, restaurant, visitDate];
